const getMaskedPhone = function (obj) {
  const main = obj.phone_array.main.replace(/\d/g, '*')
  return `${obj.phone_array.prefix}${main}${obj.phone_array.ending}`
}

export default {
  by(obj, limit = 0, withPhone = false, middleName = false, fullPhone = false, maskedPhone = false) {
    let fullName = ''

    if (obj) {
      if (obj.last_name) fullName += `${obj.last_name.trim()} `
      if (obj.first_name) fullName += `${obj.first_name.trim()} `
      if (middleName && obj.middle_name) fullName += `${obj.middle_name.trim()} `
      if (fullPhone) {
        if (withPhone && obj.phone) fullName += `${obj.phone.trim()}`
        if (maskedPhone && obj.phone_array) fullName += getMaskedPhone(obj)
      } else {
        if (withPhone && obj.phone) fullName += `${obj.phone.substr(-4)}`
      }
    }
    if (limit && fullName.length > limit) {
      return `${fullName.substr(0, limit)}...`
    }
    return fullName.trim()
  },
  getBlockedOrFiredMessage(employer) {
    let message = ` <span style="color: #ffbcbc; font-weight:300">${this.getEmployerStatus(employer)}</span>`
    employer.name = employer.name + message
    return employer
  },
  getEmployerStatus(employer) {
    if (employer.blocked_at) return '(заблокирован)'

    if (employer.end_work_at) return '(уволен)'

    return ''
  },
}
